import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationService } from '../organization.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { Chart } from 'angular-highcharts';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {defaultFormat as _rollupMoment, Moment} from 'moment';
import { MatPaginator, MatTable } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.scss'],
    providers: [
      // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
      // application's root module. We provide it at the component level here, due to limitations of
      // our example generation script.
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
      },

      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})
export class ProfileViewComponent implements OnInit, OnDestroy {
  barchartData:any;
  deviceCount: any;
  status: string = 'active';
  location: string = '';
  text: string = '';
  limit: number = 50;
  offset: number = 0;
  page = 4;
  page2 = 1;
  currentPage = 3;
  disablepage = 3;
  pagecustom = 4;
  //modal decleare
  modelOptions:any;
  closeResult:any;
    isSafari: boolean = false;
    isLoading: boolean = false;
    isLoadingModal: boolean = false;
    userList:any = [];
    userForm: FormGroup;
    statusForm:FormGroup;
    statusForm1:FormGroup;
    emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
   namePattern = /^[a-z ,.'-, 0-9]+$/i;
  downloadList:any = [];
  userData1:any;
  userData:any;
  date:any;
  searchType=""
  searchStatus='active';
  providerList= [];
  monthDisplay="";
monthNames = ["Jan", "Feb", "March", "April", "May", "June",
  "July", "August", "Sept", "Oct", "Nov", "Dec"
];
organizationId:any;
displayedColumns =[];
dataSource;
@ViewChild(MatPaginator, {static: true,read:true}) paginator: MatPaginator;
@ViewChild(MatTable,{static:false}) table: MatTable<any>;
// @ViewChild(DatatableComponent,{ static: false }) table: DatatableComponent;
  constructor(  
    private modalService: NgbModal,
    private OrganizationService :  OrganizationService,
    private router : Router,
     private fb: FormBuilder,
     private route: ActivatedRoute,
     private spinner: NgxSpinnerService,
     ) { 

      
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(param => {
      if(param['organizationId'] && param['organizationId'] !== '') {
        this.organizationId = param['organizationId'];
        this.getOrgs();
      }

    });


    this.date = new Date();
    this.monthDisplay = this.monthNames[this.date.getMonth()]+" "+this.date.getFullYear();
    if(localStorage.getItem('browser') == 'safari'){
      this.isSafari = true;
    }
    else{
      this.isSafari = false;
    }
    this.userData1 = localStorage.getItem('userData')
    this.userData =JSON.parse(this.userData1);
    this.getList();
    this.getBarChartData();
    this.getOrgs();
    }
    sortBy='';
    sortType = '';
    changePageLimit(){
      this.offset = 0
     this.getList();
    }
  changePage(event: any){

    this.currentPage = event;
    this.offset = this.limit * (this.currentPage - 1);
    this.getList();

  }
  queryParams(){
    let query;
    query='limit='+this.limit+'&offset='+this.offset * this.limit+"&organizationId="+this.organizationId;

    if(this.date){
      var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
      let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
      query = query+'&startTime='+startDate+"&endTime="+endDate
     }
    // if(this.status!= ''){
    //   query += "&status="+this.status  
    // }
    if(this.text!= ''){
      query += "&text="+this.text  
    }
    if(this.sortBy!= ''){
      query += "&sortBy="+this.sortBy  
      
    }
    if(this.sortType!= ''){
      query += "&sortType="+this.sortType 
      if(this.sortType == 'lastName'){
        this.dtAscInactive = true;
        this.dtDecInactive = true;
        this.dtDecActive = false;
        this.dtAscActive = false;
      }else{
        this.dtAscInactive1 = true;
        this.dtDecInactive1 = true;
        this.dtDecActive1 = false;
        this.dtAscActive1 = false;
      } 
    }
    return query;
  }
  dataValidate() {
    if(this.text ==''){
        this.getList();
    }
  }
  searchFilter(){
    this.offset = 0;
    this.getList();
  }
  resetFilter(){
    this.date = new Date();
    this.monthDisplay = this.monthNames[this.date.getMonth()]+","+this.date.getFullYear();
    this.offset = 0;
    this.text = '';
    this.sortBy='';
    this.sortType = '';
    this.searchType=''
    this.searchStatus='active'
  this.devAscActive= false;
  this.devDecActive= false;
  this.devAscInactive= true;
  this.devDecInactive= true;
  this.usrAscActive= false;
  this.usrDecActive = false;
  this.usrAscInactive= true;
  this.usrDecInactive=true;
  this.dtAscActive=false;
  this.dtDecActive= false;
  this.dtAscInactive= true;
  this.dtDecInactive= true;
    this.getList();
  }
 

  getList() {
    var queryValue = this.queryParams();
    this.userData1 = localStorage.getItem('userData')
    this.userData =JSON.parse(this.userData1);
    this.spinner.show();
    this.getBarChartData();
    this.OrganizationService.getProfilePatient(queryValue).subscribe(
      res => {
        this.spinner.hide();
        if ((res["message"] == "Success")) {
          this.userList = res["data"]["auditLogs"];
          this.deviceCount = res["data"]["totalCount"];
        } else {
          this.userList = [];
        }
      },
      err => {
        this.spinner.hide();
      }
    );
  }

  chart1:any;

getPageSymbol(current: number) {
return ['A', 'B', 'C', 'D', 'E', 'F', 'G'][current - 1];
}
 


 
  private modalRef: NgbModalRef;
  userDetails:any;
  isEdit:boolean = false;

  
  patchDevice(){
    this.userForm.patchValue({
      firstName: this.userDetails['firstName'],
      lastName: this.userDetails['lastName'],
      email: this.userDetails['email'],
      location: this.userDetails['location'],

      
    });

  }
  
  closeModal(){
    this.modalRef.close();
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnDestroy(): void {
  }

  //sorting login

  devAscActive: boolean = false;
  devDecActive: boolean = false;
  devAscInactive: boolean = true;
  devDecInactive: boolean = true;
  usrAscActive: boolean = false;
  usrDecActive: boolean = false;
  usrAscInactive: boolean = true;
  usrDecInactive: boolean = true;
  dtAscActive: boolean = false;
  dtDecActive: boolean = false;
  dtAscInactive: boolean = true;
  dtDecInactive: boolean = true;

  dtAscActive1: boolean = false;
  dtDecActive1: boolean = false;
  dtAscInactive1: boolean = true;
  dtDecInactive1: boolean = true;

  sorting(sortBy : any, sortType : any, clicked : any){
    this.sortBy = sortBy;
    this.sortType = sortType;

    
    if(clicked == 'dtAscInactive1' && sortType == 'lastName'){
      this.dtAscActive1 = true;
      this.dtDecActive1 = false;
      this.dtAscInactive1 = false;
      this.dtDecInactive1 = true;
      
    }

    if(clicked == 'dtAscActive1'  && sortType == 'lastName'){
      this.dtAscActive1 = false;
      this.dtDecActive1 = false;
      this.dtAscInactive1 = true;
      this.dtDecInactive1 = true;
      
    }
    if(clicked == 'dtDecActive1'  && sortType == 'lastName'){
      this.dtAscActive1 = false;
      this.dtDecActive1 = false;
      this.dtAscInactive1 = true;
      this.dtDecInactive1 = true;
      
    }
    
    if(clicked == 'dtDecInactive1'  && sortType == 'lastName'){
      this.dtAscActive1 = false;
      this.dtDecActive1 = true;
      this.dtAscInactive1 = true;
      this.dtDecInactive1 = false;
      
    }



 
    if(clicked == 'dtAscInactive' && sortType == 'profileAccessedAt'){
      this.dtAscActive = true;
      this.dtDecActive = false;
      this.dtAscInactive = false;
      this.dtDecInactive = true;
      
    }

    if(clicked == 'dtAscActive'  && sortType == 'profileAccessedAt'){
      this.dtAscActive = false;
      this.dtDecActive = false;
      this.dtAscInactive = true;
      this.dtDecInactive = true;
      
    }
    if(clicked == 'dtDecActive'  && sortType == 'profileAccessedAt'){
      this.dtAscActive = false;
      this.dtDecActive = false;
      this.dtAscInactive = true;
      this.dtDecInactive = true;
      
    }
    
    if(clicked == 'dtDecInactive'  && sortType == 'profileAccessedAt'){
      this.dtAscActive = false;
      this.dtDecActive = true;
      this.dtAscInactive = true;
      this.dtDecInactive = false;
      
    }

    


  
    if(clicked == 'devAscActive' ||clicked == 'usrAscActive' ||  clicked == 'vrsnAscActive' || clicked == 'dtAscActive' || clicked == 'locAscActive'|| clicked == 'devDecActive' ||clicked == 'usrDecActive' ||  clicked == 'vrsnDecActive' || clicked == 'dtDecActive'){
     this.sortBy = this.sortType = '';
    }
    this.getList();
  }
 
  onlyNumberKey(event:any) {
    // if(event.charCode == '46') {
    //   return
    // }
  return (event.charCode == 8 || event.charCode == 0 ) ? null : event.charCode >= 46 && event.charCode <= 57;
  
}
changeStatus(){
  this.offset = 0
  this.getList();
}
setMonthAndYear(normalizedMonthAndYear:any, datepicker:any) {
  this.date =normalizedMonthAndYear['_d'];
   datepicker.close();
   this.monthDisplay = this.monthNames[this.date.getMonth()]+","+this.date.getFullYear();
   this.getList();
  this.barchartData();
}
uniqueProvider:number =0
MonthList:any;
getBarChartData() {
  let query=""
  if(this.date){
    var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
    var firstDay = new Date(year, month, 1);
    var lastDay = new Date(year, month + 1, 0);
    let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
    let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
    query = query+'&startTime='+startDate+"&endTime="+endDate +"&organizationId="+this.organizationId
   }
  this.OrganizationService.getBarChart(query).subscribe(
    res => {
      if ((res["statusCode"] == 200)) {
        this.MonthList = [];
        this.barchartData =[]
        this.uniqueProvider = res.data.uniqueUsers;
        res.data.profileAccessMonthWise.forEach((element: { [x: string]: any }) => {
          this.MonthList.push(element['month'])
          this.barchartData.push({name:element['month'],y:element['count'],color:'#8bc33a'})
        });
        this.chart1 = new Chart({
          chart: {
            type: 'column'
          },
          title: {
            text: 'Profile Access by Month'
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            categories:this.MonthList,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title:{ text:""},
          },
          tooltip: {
            shared: true,
            useHTML: true,  
            pointFormat: '',
            headerFormat: `<span>Views: {point.y}</span>`,
          },
          credits: {
            enabled: false,
          },
          plotOptions: {
            series: {
              cursor: "pointer",
              point: {
                events: {
                  click: (event) => {
                    this.callExternalFunction(event); //call function  with arguments
                  },
                },
              },
            },
          },
          series: [{
            type:'column',
            data: this.barchartData,
            showInLegend: false ,
            pointWidth:10

          }],
        });
      } else {
        
      }
    },
    err => {
    
    }
  );
}
setMonthAndYear1(event:any){
  this.getList();
 
}
callExternalFunction(event:any){
  let data= event.point.category.split('-');
  let month ="";
  let year = data[1];
  let date = "01"
    if(data[0]=='Jan'){month="01"}
    else if(data[0]=='Feb'){month="02"}
    else if(data[0]=='Mar'){month="03"}
    else if(data[0]=='Apr'){month="04"}
    else if(data[0]=='May'){month="05"}
    else if(data[0]=='Jun'){month="06"}
    else if(data[0]=='Jul'){month="07"}
    else if(data[0]=='Aug'){month="08"}
    else if(data[0]=='Sep'){month="09"}
    else if(data[0]=='Oct'){month="10"}
    else if(data[0]=='Nov'){month="11"}
    else if(data[0]=='Dec'){month="12"}
   
    setTimeout(() => {
      /** spinner ends after 1 seconds */
      let dataStr=year+'-'+month+'-'+date;
      
      this.date = new Date(dataStr);
      this.monthDisplay = this.monthNames[this.date.getMonth()]+" "+this.date.getFullYear();
      this.getList()
      this.updateUniqueUser();
      this.getBarChartData();
    }, 1000);
   
}
updateUniqueUser() {
  let query=""
  if(this.date){
    var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
    var firstDay = new Date(year, month, 1);
    var lastDay = new Date(year, month + 1, 0);
    let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
    let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
    query = query+'&startTime='+startDate+"&endTime="+endDate +"&organizationId="+this.organizationId
   }
  this.OrganizationService.getBarChart(query).subscribe(
    res => {
      if ((res["statusCode"] == 200)) {
      this.uniqueProvider = res.data.uniqueUsers;
      } else {
        
      }
    },
    err => {
    
    }
  );
}
organizationDetail:any
getOrgs() {
  let param = 'organizationId='+this.organizationId;
  this.OrganizationService.getOrganizationsApi(param).subscribe(res => {
    this.isLoading=true;
    if ((res["status"] == "Success")) {
      this.organizationDetail = res.data.organizationList[0];
 
    }
  }, err => {
    this.isLoading = false;
  });

}

HistoryList = [];
openModalApp(content:any, btn:any, data:any) {
  if(data['providersCount'] == 0){
   return null
  }
     this.modelOptions = {
       backdrop: "static",
       keyboard: false,
       size: "lg",
       centered: true,
     };
     this.userData1 = data;
 let query="userId="+this.userData1['userId'];
 if(this.date){
   var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
   var firstDay = new Date(year, month, 1);
   var lastDay = new Date(year, month + 1, 0);
   let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
   let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
   query = query+'&startTime='+startDate+"&endTime="+endDate
  }
 this.spinner.show();
 this.HistoryList =[];
     this.OrganizationService.getProfileAccessLogs(query).subscribe(
       res => {
        this.spinner.hide();
         if ((res["message"] == "Success")) {
           this.HistoryList= res.data.auditLogs;
           btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
           this.modalRef = this.modalService.open(content, this.modelOptions);
           this.modalRef.result.then(
             (result) => {
               this.closeResult = `Closed with: ${result}`;
             },
             (reason) => {
               this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
             }
           );
         } else {

         }
         this.spinner.hide();
         this.isLoading = false;
       },
       err => {
         this.isLoading = false;
       }
     );
    
   }
   pageChange(event:any){
    this.offset = event.pageIndex
    this.limit = event.pageSize;
    this.getList()
   }
}
